import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommunityRoomsinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M4 16L32 6l28 10" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 32,
				cy: 25,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M30.705 31h2.59a1 1 0 0 1 .942.664L39 45H25l4.763-13.336a1 1 0 0 1 .942-.664z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 25,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M13.92 31h6.16a1 1 0 0 1 .996.917L22 43H12l.924-11.083A1 1 0 0 1 13.92 31zM15 55h4a1 1 0 0 0 1-1V43h-6v11a1 1 0 0 0 1 1z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 47,
				cy: 25,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", { d: "M43.92 31h6.16a1 1 0 0 1 .996.917L52 43H42l.924-11.083A1 1 0 0 1 43.92 31zM45 55h4a1 1 0 0 0 1-1V43h-6v11a1 1 0 0 0 1 1zm-14.095 0h2.19a1 1 0 0 0 .995-.9L35 45h-6l.91 9.1a1 1 0 0 0 .995.9z" })
		]
	})
});
export default SvgCommunityRoomsinline;
